import {inject, Injectable} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {translate} from '@jsverse/transloco';
import {ProjectConclusionDeclineDialogComponent} from './project-conclusion-decline-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ProjectConclusionDeclineDialogService {
  private readonly dialogService = inject(DialogService);

  confirmDecline(options: {
    initialComment?: string;
    accept: (comment: string) => void;
    decline: (comment: string) => void;
  }): void {
    const ref = this.dialogService.open(ProjectConclusionDeclineDialogComponent, {
      header: translate('provider.tenderWizard.phase.confirmation.header'),
      modal: true,
      data: {
        comment: options.initialComment,
      },
      closable: true,
      closeOnEscape: true,
    });

    ref?.onClose.subscribe((result: {comment: string; confirmed: boolean} | undefined) => {
      if (result) {
        options.decline(result.comment);

        if (result.confirmed) {
          options.accept(result.comment);
        }
      }
    });
  }
}
